export default __webpack_public_path__ + "static/media/liveDataIconBlack.2c3652e3.svg";